import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { SessionService } from '../../../services/session/session.service';
import { AccountConfigService } from '../../../services/account-config/account-config.service';

@Component({
  selector: 'ags-session-consigne',
  templateUrl: './session-consigne.component.html',
  styleUrls: ['./session-consigne.component.scss']
})
export class SessionConsigneComponent implements OnInit {
  @HostBinding('class') themeFlag;
  public listMenu;
  public idSession;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }

  @Input('listMenu')
  set _listMenu(value: { provenance: string; consigne: string }[]) {
    if (value) {
      this.listMenu = value;
    }
  }

  constructor(private sessionService: SessionService, private accountConfigService: AccountConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }
}
